import { supabase } from '@/lib/supabase';
import { SubprojectBudgetInsert } from '@/shared/types/api';

export interface AssignKpiToSubprojectsInput {
  kpiId: number;
  subprojects: {
    clientViewId: number;
    budget: number | undefined;
  }[];
}

export const assignKpiToSubprojects = async ({
  kpiId,
  subprojects,
}: AssignKpiToSubprojectsInput) => {
  const assignments: SubprojectBudgetInsert[] = subprojects.map(
    (subproject) => ({
      kpi_id: kpiId,
      budget: subproject.budget || null,
      subproject_view_id: subproject.clientViewId,
    }),
  );

  const { data, error } = await supabase.rpc('appoint_kpi', {
    p_kpi_assignments: assignments,
  });

  if (error) {
    throw error;
  }

  return data;
};
